<template>
  <el-dialog
    class="com_dialog"
    ref="comDialog"
    :fullscreen="attrs.fullscreen || false"
    v-bind="attrs"
    v-on="$listeners"
    :style="{'--paddings': attrs.paddings}"
    >
    <template v-if="$slots.title" slot="title">
      <slot name="title" />
    </template>
    <template v-else slot="title">
      <div class="original-title">
        <h3 v-if="attrs && attrs.titles">{{ attrs.titles }}
          <el-tooltip v-if="attrs && attrs.titleInfo" :content="attrs.titleInfo" placement="bottom">
            <svg class="icon svg-icon icon-help" aria-hidden="true">
              <use xlink:href="#icon-bangchu14"></use>
            </svg>
          </el-tooltip>
        </h3>
        <el-tooltip v-if="attrs && attrs.secTitle" placement="bottom" overflow>
          <template slot="content">
            <p v-html="attrs.secTitle"></p>
          </template>
          <p v-html="attrs.secTitle"></p>
        </el-tooltip>
      </div>
    </template>
    <slot />
    <template v-if="$slots.footer" slot="footer">
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'CommonDialog',
  inheritAttrs: false,
  computed: {
    attrs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.$attrs.paddings = '16px 24px 15px'
      if (this.$attrs.title) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$attrs.titles = this.$attrs.title
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$attrs.secTitle = this.$attrs['sec-title'] || this.$attrs['secTitle']
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$attrs.paddings = this.$attrs.secTitle ? '13px 24px 12px' : '11px 24px 10px'
        delete this.$attrs.title
      }
      return this.$attrs
    }
  },
  watch: {
    attrs(val) {
      // console.log(val.secTitle)
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    // console.log(this.$attrs)
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.com_dialog {
  ::v-deep .el-dialog {
    overflow: hidden;
    .el-dialog__header {
      background: #FAFAFC;
      padding: var(--paddings);
      .original-title {
        width: calc(100% - 30px);
        h3 {
          margin: 0;
          line-height: 26px;
          font-weight: 500;
          color: #1D2129;
          font-size: 18px;
          white-space: nowrap;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        p {
          font-size: 12px;
          font-weight: 400;
          color: #86909C;
          line-height: 20px;
          white-space: nowrap;
          width: 100%;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }

    }
    .el-dialog__footer {
      border-top: 0 !important;
    }
  }
}

</style>
<style lang="scss">
.el-tooltip__popper-content {
  p {
    word-break: break-all;
  }
}
</style>
